<template>
    <component
        :is="tag"
        class="row"
        :class="rowClasses"
        :alignContent="alignContent">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
    </component>
</template>

<script>
/**
 * `<SbsRow>` - это контейнер для колонок сетки. Каждая колонка имеет горизонтальный паддинг для добавления отступов между ними. Этот отступ компенсируется отрицательными маргинами у `<SbsRow>`. Таким образом, все содержимое колонок визуально выравнивается по левому краю
 */
export default {
    name: 'SbsRow',
    computed: {
        rowClasses() {
            const classesObject = {
                'no-gutters': this.noGutters,
            };
            const classesArray = [];

            if (this.alignV) classesArray.push(`align-items-${this.alignV}`);

            if (this.alignH) classesArray.push(`justify-content-${this.alignH}`);

            if (this.cols) classesArray.push(`row-cols-${this.cols}`);

            if (this.colsSm) classesArray.push(`row-cols-sm-${this.colsSm}`);

            if (this.colsMd) classesArray.push(`row-cols-md-${this.colsMd}`);

            if (this.colsLg) classesArray.push(`row-cols-lg-${this.colsLg}`);

            if (this.colsXl) classesArray.push(`row-cols-xl-${this.colsXl}`);

            if (this.alignContent) classesArray.push(`align-content-${this.alignContent}`);

            classesArray.push(classesObject);

            return classesArray;
        },
    },
    props: {
        /**
         * Выравнивание элементов колонок по поперечной оси: `start`, `center`, `end`, `around`, `between` или `stretch`
         */
        alignContent: {
            type: String,
            default: null,
        },
        /**
         * Горизонтальное выравнивание/интервал всех колонок: `start`, `center`, `end`, `around` или `between`
         */
        alignH: {
            type: String,
            default: null,
        },
        /**
         * Вертикальное выравнивание всех колонок в строке: `start`, `center`, `end`, `baseline` или `stretch`
         */
        alignV: {
            type: String,
            default: null,
        },
        /**
         * Определяет количество колонок внутри контейнера
         */
        cols: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок внутри контейнера, начиная с брейкпоинта `sm`
         */
        colsSm: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок внутри контейнера, начиная с брейкпоинта `md`
         */
        colsMd: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок внутри контейнера, начиная с брейкпоинта `lg`
         */
        colsLg: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет количество колонок внутри контейнера, начиная с брейкпоинта `xl`
         */
        colsXl: {
            type: [Number, String],
            default: null,
        },
        /**
         * Когда установлено, удаляет отступы у себя и у дочерних колонок.
         */
        noGutters: {
            type: Boolean,
            default: false,
        },
        /**
         * Определяет тег HTML для контейнера
         */
        tag: {
            type: String,
            default: 'div',
        },
    },
};
</script>
